/**
 * The drivers module's paths.
 *
 * `/drivers` is the roster, `/drivers/:driverId` is one person, `/drivers/unidentified`
 * is rule 5's actionable list, and `/immobilizer` — which lives in this module because
 * the thing it can do is strand a driver — is the vehicle picker for the immobilizer
 * console, with `/immobilizer/vehicles/:vehicleId` as the control itself.
 *
 * Route paths stay in English while the UI defaults to French: a localized URL set
 * would mean two routing tables and a redirect on every language switch.
 *
 * Registration lives in `routes/app-routes.tsx`, which this phase does not own — see
 * NOTES-PHASE6-WEB.md §1 for the exact patch, including which permission gates each
 * one. The immobilizer routes are gated on `devices:immobilizer`, which stops at
 * tenant_admin and must not be widened.
 */

export const DRIVERS_PATH = '/drivers'
export const DRIVER_DETAIL_PATH = '/drivers/:driverId'
export const UNIDENTIFIED_TRIPS_PATH = '/drivers/unidentified'
export const IMMOBILIZER_PATH = '/immobilizer'
export const VEHICLE_IMMOBILIZER_PATH = '/immobilizer/vehicles/:vehicleId'

export const DRIVERS_QUERY_KEYS = {
  q: 'q',
  status: 'status',
  /** `1` filters to drivers no device can ever recognise — see rule 5. */
  noKey: 'noKey',
} as const

export function driversPath(params: { q?: string; status?: string; noKey?: boolean } = {}): string {
  const search = new URLSearchParams()
  if (params.q) search.set(DRIVERS_QUERY_KEYS.q, params.q)
  if (params.status) search.set(DRIVERS_QUERY_KEYS.status, params.status)
  if (params.noKey) search.set(DRIVERS_QUERY_KEYS.noKey, '1')
  const query = search.toString()
  return query.length > 0 ? `${DRIVERS_PATH}?${query}` : DRIVERS_PATH
}

export function driverDetailPath(driverId: string): string {
  return `/drivers/${driverId}`
}

export function unidentifiedTripsPath(): string {
  return UNIDENTIFIED_TRIPS_PATH
}

export function vehicleImmobilizerPath(vehicleId: string): string {
  return `/immobilizer/vehicles/${vehicleId}`
}
